export const productionConfig = {
    dcbService: `${process.env.VUE_APP_DCB_SERVICE}`,
    authHeader: `${process.env.VUE_APP_AUTHORIZATION_HEADERS}`,
    quizIncRedirectUrl: `${process.env.VUE_APP_QUIZ_INC_REDIRECT_URL}`,
    quizIncTermsConditionsHub: `${process.env.VUE_APP_QUIZ_INC_TERMS_CONDITIONS_URL}`,
    campaignHubService: `${process.env.VUE_APP_CAMPAIGN_HUB_SERVICE}`,
    upstreamService: `${process.env.VUE_APP_UPSTREAM_SERVICE}`,
}

export const stagingConfig = {
    dcbService: `${process.env.VUE_APP_DCB_SERVICE}`,
    authHeader: `${process.env.VUE_APP_AUTHORIZATION_HEADERS}`,
    quizIncRedirectUrl: `${process.env.VUE_APP_QUIZ_INC_REDIRECT_URL}`,
    quizIncTermsConditionsHub: `${process.env.VUE_APP_QUIZ_INC_TERMS_CONDITIONS_URL}`,
    campaignHubService: `${process.env.VUE_APP_CAMPAIGN_HUB_SERVICE}`,
    upstreamService: `${process.env.VUE_APP_UPSTREAM_SERVICE}`,
}

const environment = getEnvironment()

export const environmentConfig = getEnvObject();

function getEnvironment() {
    let base_url = window.location.origin;
    if (base_url.includes('staging')) return 'staging'
    if (base_url.includes('localhost')) return 'development'
    else return 'production'
}

function getEnvObject() {
    if (environment === 'staging') return stagingConfig
    if (environment === 'development') return productionConfig
    if (environment === 'production') return productionConfig
}
